import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Auth } from 'aws-amplify';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import FormForgotPassword from './molecules/FormForgotPassword';
import FormRecoveryPassword from './molecules/FormRecoveryPassword';
import { isEmail } from '../../shared/utils/helpers';

const styles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.white : '#424242',
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const initialState = {
  username: '',
  code: '',
  password: '',
};

const ForgotPassword = ({ history, user }) => {
  const classes = styles();
  const [values, setValues] = useState(initialState);
  const [labelWidth, setLabelWidth] = useState(0);
  const [isError, setError] = useState(false);
  const [isRecovery, setisRecovery] = useState(false);

  const labelRef = React.useRef(null);
  const isSubmitDisabled = isError || !(values.username && values.password);

  useEffect(() => {
    setLabelWidth(labelRef.current.offsetWidth);
  }, []);

  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleSubmit = async event => {
    try {
      event.preventDefault();
      await Auth.forgotPassword(values.username);
      setisRecovery(true);
    } catch (e) {
      throw e;
    }
  };

  const handleNewPassword = async () => {
    try {
      await Auth.forgotPasswordSubmit(values.username, values.code, values.password);
      history.push('/login');
    } catch (e) {
      throw e;
    }
  };

  const handleEmail = () => {
    if (!isEmail(values.username)) setError(true);
    else setError(false);
  };

  if (user.isAuthenticated) {
    return <Redirect to="/" />;
  }

  return isRecovery ? (
    <FormRecoveryPassword
      labelWidth={labelWidth}
      username={values.username}
      code={values.code}
      password={values.password}
      isError={isError}
      isSubmitDisabled={isSubmitDisabled}
      classes={classes}
      labelRef={labelRef}
      onEmail={handleEmail}
      onNewPassword={handleNewPassword}
      onChange={handleChange}
    />
  ) : (
    <FormForgotPassword
      labelWidth={labelWidth}
      username={values.username}
      isError={isError}
      classes={classes}
      labelRef={labelRef}
      onEmail={handleEmail}
      onSubmit={handleSubmit}
      onChange={handleChange}
    />
  );
};

ForgotPassword.propTypes = {
  history: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = store => ({
  user: store.user,
});

export default connect(mapStateToProps)(ForgotPassword);
